<template>
  <el-popover ref="mypopover" placement="down" width="630" trigger="click" popper-class="myaddresspopover">
    <div class="pd20">
      <div class="flex">
        <el-input
          placeholder="搜索"
          prefix-icon="el-icon-search"
          v-model.trim="filterAddress"
          @input="inputFilterAddresss"
        ></el-input>
        <el-button type="plain" class="addresss" @click="onAddAddress" v-if="needAddAddr=='true'">
          <i class="iconfont sfadd-sy address_icon"></i>添加地址
        </el-button>
      </div>
      <div class="addresslist">
        <ul class="scrollBar">
          <li v-for="(item,index) in list" :key="index" @click="onfallback(item)">
            <span class="mr20" v-if="item.shortName">{{ item.shortName}}</span>
            <span class="fs12 gray_little mr20">{{ item.address }}</span>
            <span class="fs12 gray_little">{{ item.contacts +'/'+ item.phone }}</span>
          </li>
        </ul>
      </div>
    </div>
    <el-button
      slot="reference"
      type="plain"
      size="mini"
      class="ml10 addAddress"
      icon="iconfont sfhuabanfuben"
    >地址簿</el-button>
  </el-popover>
</template>

<script>
export default {
  name: "SelectAddr",
  props: {
    addressList: {
      type: Array,
      default: [],
    },
	needAddAddr: {
	  type: String,
	  default: 'true',
	}
  },
  data() {
    return {
      filterAddress: "",
      list: [],
    };
  },
  methods: {
    onfallback(item) {
        this.$emit('on-select',item)
        this.$refs.mypopover.doClose()
    },
    inputFilterAddresss(qs) {
      let list = this.addressList.slice();
      let results = qs ? list.filter(this.filterFun(qs)) : list;
      this.list = results;
    },
    filterFun(qs) {
      return (item) => {
        return (
          (item.shortName && item.shortName.indexOf(qs) !== -1) ||
          item.address.indexOf(qs) !== -1 ||
          item.contacts.indexOf(qs) !== -1 ||
          item.phone.indexOf(qs) !== -1
        );
      };
    },
    onAddAddress() {
      this.$emit('on-newaddress')
    },
  },
  computed: {},
  watch: {
    addressList(val) {
      this.list = val.slice();
    },
  },
  mounted() {
      this.list = this.addressList.slice();
  },
};
</script>

<style scoped lang='less'>
.mr20{
  margin-right: 15px!important;
}
</style>
